export const ICON_POSITION_START = 'start';
export const ICON_POSITION_END = 'end';